import Papa from "papaparse";
import { useEffect, useState } from "react";

export default function DoctorTable() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isFallback, setIsFallback] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: "Day", direction: "asc" });
  const baseDayOrder = ["Saturday","Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];

  const USE_SHEET = true; // true → Google Sheet, false → local data

  const fallbackData = [
    {
      Name: "Dr. Jambada Gajendra",
      Speciality: "Ayurveda",
      "Visit Pattern": "Every 3rd",
      Day: "Monday",
      Time: "5:00 PM – 6:00 PM"
    },
    {
      Name: "Dr. Arun Subash Reddy",
      Speciality: "Ophthalmologist",
      "Visit Pattern": "2nd & 4th",
      Day: "Tuesday",
      Time: "4:00 PM – 5:00 PM"
    },
    {
      Name: "Dr. Venkata Muni Reddy",
      Speciality: "ENT",
      "Visit Pattern": "2nd & 4th",
      Day: "Tuesday",
      Time: "4:30 PM – 5:30 PM"
    },
    {
      Name: "Dr. Sahithi V",
      Speciality: "Dental",
      "Visit Pattern": "Every 3rd",
      Day: "Wednesday",
      Time: "5:00 PM – 6:00 PM"
    },
    {
      Name: "Dr. Sindhura Y",
      Speciality: "Paediatric",
      "Visit Pattern": "2nd & 4th",
      Day: "Thursday",
      Time: "5:00 PM – 6:00 PM"
    },
    {
      Name: "Dr. Javvadi Nihar",
      Speciality: "Orthopaedic",
      "Visit Pattern": "2nd & 4th",
      Day: "Thursday",
      Time: "5:00 PM – 6:00 PM"
    },
    {
      Name: "Dr. Keerthi Charupalli",
      Speciality: "Dermatologist",
      "Visit Pattern": "Weekly",
      Day: "Friday",
      Time: "4:30 PM – 6:00 PM"
    },
    {
      Name: "Dr. Madhu Azad",
      Speciality: "Homeopathy",
      "Visit Pattern": "1st",
      Day: "Saturday",
      Time: "11:00 AM – 12:00 PM"
    }
  ];

    // 🔄 Get dynamic week order (today first)
  const getDynamicDayOrder = () => {
    // const today = new Date().toLocaleString("en-US", { weekday: "long" });
    const todayIndex = new Date().getDay(); // 0 = Sunday
    const today = baseDayOrder[todayIndex === 0 ? 6 : todayIndex - 1]; // Adjust for Sunday
    const index = baseDayOrder.indexOf(today);

    if (index === -1) return baseDayOrder;

    return [
      ...baseDayOrder.slice(index),
      ...baseDayOrder.slice(0, index)
    ];
  };

    const dynamicDayOrder = getDynamicDayOrder();

    const today = new Date().toLocaleString("en-US", { weekday: "long" });

  useEffect(() => {
    if (!USE_SHEET) {
      // Directly use local data
      setData(fallbackData);
      setLoading(false);
      return;
    }
    Papa.parse("https://docs.google.com/spreadsheets/d/e/2PACX-1vSne9H8a27MZmyFuKbdawJbmNnAGmeXwCbs5N0E-vs0kNnYrK_6vkMVVFVoDluI0GjUYX4yFbMBcXim/pub?gid=0&single=true&output=csv", {
      download: true,
      header: true,
      complete: (result) => {
        const clean = result.data.filter(row => row.Name);

        if (clean.length > 0) {
          setData(clean);
        } else {
          throw new Error("Empty data");
        }

        setLoading(false);
      },
      error: () => {
        // fallback
        setData(fallbackData);
        setIsFallback(true);
        setLoading(false);
      }
    });
  }, []);

  // Sorting logic
  const sortedData = [...data].sort((a, b) => {
    if (!sortConfig) return 0;

    const { key, direction } = sortConfig;

        // Special handling for Day
    if (key === "Day") {
      const indexA = dynamicDayOrder.indexOf(a.Day);
      const indexB = dynamicDayOrder.indexOf(b.Day);
      return direction === "asc" ? indexA - indexB : indexB - indexA;
    }

    const valA = a[key] || "";
    const valB = b[key] || "";

    if (valA < valB) return direction === "asc" ? -1 : 1;
    if (valA > valB) return direction === "asc" ? 1 : -1;
    return 0;
  });

  const handleSort = (key) => {
    let direction = "asc";

    if (sortConfig && sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }

    setSortConfig({ key, direction });
  };

  const getArrow = (key) => {
    if (!sortConfig || sortConfig.key !== key) return "";
    return sortConfig.direction === "asc" ? " ▲" : " ▼";
  };


  return (
    <div style={{ padding: "20px" }}>
      {/* <h2>Specialist Visit Schedule</h2> */}

      {loading ? (
        <div style={{ textAlign: "center", padding: "40px" }}>
          <div className="spinner"></div>
          <p>Loading doctors...</p>
        </div>
      ) : (
        <>
          {isFallback && (
            <p style={{ color: "orange", marginBottom: "10px" }}>
              Showing last available schedule (live data unavailable)
            </p>
          )}

          <table style={styles.table}>
            <thead>
              <tr>
                <th onClick={() => handleSort("Name")}>Name{getArrow("Name")}</th>
                <th onClick={() => handleSort("Speciality")}>Speciality{getArrow("Speciality")}</th>
                <th onClick={() => handleSort("Visit Pattern")}>Visit Pattern{getArrow("Visit Pattern")}</th>
                <th onClick={() => handleSort("Day")}>Day{getArrow("Day")}</th>
                <th onClick={() => handleSort("Time")}>Time{getArrow("Time")}</th>
              </tr>
            </thead>
            <tbody>
              {sortedData.map((doc, index) => (
                <tr key={index} style={doc.Day === today ? { backgroundColor: "#e6f7ff" } : {}}>
                  <td>{doc.Name}</td>
                  <td>{doc.Speciality}</td>
                  <td>{doc["Visit Pattern"]}</td>
                  <td>{doc.Day}</td>
                  <td>{doc.Time}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}

      <style>{`
        th.active {
          color: blue;
        }
        .spinner {
          margin: auto;
          border: 4px solid #eee;
          border-top: 4px solid #333;
          border-radius: 50%;
          width: 40px;
          height: 40px;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        th {
          background-color: #f5f5f5;
          padding: 10px;
          text-align: left;
        }

        td {
          padding: 10px;
          border-top: 1px solid #ddd;
        }

        tr:hover {
          background-color: #f9f9f9;
        }
      `}</style>
    </div>
  );
}

const styles = {
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "20px"
  }
};